const AD_PARAM_ORDER = ['utm', 'google_ads', 'meta', 'naver_search_ads', 'kakao']

function normalizeDefaultAdParams (defaultAdParams) {
  const grouped = (defaultAdParams || []).reduce((acc, item) => {
    const code = AD_PARAM_ORDER.includes(item.code) ? item.code : 'etc'
    const label = code === 'etc' ? 'Etc' : item.label

    if (!acc[code]) {
      acc[code] = {
        code,
        label,
        params: []
      }
    }

    item.params.forEach(param => {
      if (!acc[code].params.find(target => target.key === param.key)) {
        acc[code].params.push(param)
      }
    })

    return acc
  }, {})

  return AD_PARAM_ORDER
    .concat('etc')
    .filter(code => grouped[code])
    .map(code => grouped[code])
}

export function getAdParamCategories (defaultAdParams) {
  return normalizeDefaultAdParams(defaultAdParams).map(item => ({
    value: item.code,
    label: item.label,
    count: item.params.length
  }))
}

export function getAdParamTagMap (defaultAdParams) {
  return normalizeDefaultAdParams(defaultAdParams).reduce((acc, item) => {
    acc[item.code] = item.params.map(param => param.key).filter(Boolean)
    return acc
  }, {})
}

export function getAllDefaultAdParamKeys (defaultAdParams) {
  return normalizeDefaultAdParams(defaultAdParams).reduce((acc, item) => {
    item.params.forEach(param => {
      if (param.key) {
        acc.push(param.key)
      }
    })
    return acc
  }, [])
}

export function normalizeAdParamKeys (params) {
  return [...new Set((Array.isArray(params) ? params : [])
    .map(param => typeof param === 'string' ? param.trim() : '')
    .filter(Boolean))]
}

export function buildExactAdParamConfig ({ enabled, customAdParams }) {
  return {
    enabled: Boolean(enabled),
    removeParams: enabled
      ? normalizeAdParamKeys(customAdParams)
      : []
  }
}
